export default "__VITE_ASSET__C4H8lX1g__"